import axios from 'axios';

// 创建axios实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // api的base_url
    timeout: 30000 // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 可以在这里添加请求头等信息
        config.headers['TRON-PRO-API-KEY'] = '401d21ff-35da-4c7d-ae18-9b1240463fb2';
        return config;
    },
    error => {
        // 请求错误处理
        console.log(error); // for debug
        Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        // 对响应数据做处理，例如只返回data部分
        // 如果返回的状态码为200，说明成功，可以直接返回数据
        if (response.status === 200) {
            return response.data;
        } else {
            // 其他状态码都当作错误处理
            // 可以在这里对不同的错误码进行不同处理
            return Promise.reject({
                message: response.statusText || 'Error',
                status: response.status
            });
        }
    },
    error => {
        // 对响应错误做处理
        console.log('err' + error); // for debug
        return Promise.reject(error);
    }
);

export default service;
